/* tslint:disable:interface-over-type-literal */
import { ref } from 'vue';
import { roleWebservice } from '@/webservices/v2/role';
import { goToCurrent } from '@/helpers/routing/links';

type AppexUser =
    | {
          id: string;
          firstname: string;
          lastname: string;
          email: string;
          is_superadmin: boolean;
          company?: AppexCompany;
          role?: AppexUserRole;
      }
    | undefined
    | null;

type AppexCompany = {
    id: string;
    name: string;
    created_at: string;
    updated_at: string;
};

type AppexPermission = {
    key: string;
    required: boolean;
};

export type AppexUserRole = {
    id: number;
    name: string;
    permissions?: AppexPermission[];
};

export type AppexUserScope = {
    company?: AppexCompany;
    role?: AppexUserRole;
    user?: AppexUser;
};

export type AuthScope = AppexUserScope;

const scopes = ref<AuthScope[]>();
const activeScope = ref<AuthScope>();

const scopesKey = 'appex_scopes';
const activeScopeKey = 'appex_active_scope';

export const useAuthScopes = () => {
    const localScopes = localStorage.getItem(scopesKey);
    if (localScopes !== null) {
        scopes.value = JSON.parse(localScopes) as AuthScope[];
    }

    const localActiveScope = localStorage.getItem(activeScopeKey);
    if (localActiveScope !== null) {
        activeScope.value = JSON.parse(localActiveScope) as AuthScope;
    }

    const setActiveScope = async (scope?: AuthScope): Promise<void> => {
        if (!scope) {
            return;
        }
        activeScope.value = scope;
        localStorage.setItem(activeScopeKey, JSON.stringify(activeScope.value));

        try {
            const roleResponse = await roleWebservice.get();
            activeScope.value = { ...activeScope.value, role: roleResponse.data.data };
            localStorage.setItem(activeScopeKey, JSON.stringify(activeScope.value));
        } catch (error) {
            goToCurrent('auth/logout');
        }
    };

    const setScopes = (newScopes: AuthScope[]): void => {
        scopes.value = newScopes;

        localStorage.setItem(scopesKey, JSON.stringify(scopes.value));
    };

    return {
        setScopes,
        setActiveScope,
        scopes,
        activeScope,
    };
};
